import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { matchBankStatementsWithOrdersAction } from '../../../services/request';
import { Box, Card, CardHeader, CardContent, IconButton, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import { GridToolbar, plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const columns = [
  { field: 'weight_percentage', headerName: 'Procent dopasowania %', flex: 0.3, valueGetter: params => (params.row.weight_percentage * 100).toFixed(2) },
  { field: 'order_number', headerName: 'Numer zamówienia', flex: 0.3, valueGetter: params => params.row.order.identifier },
  { field: 'agreement_number', headerName: 'Numer umowy', flex: 0.3, valueGetter: params => params.row.order.agreements__identifier },
  { field: 'guardian', headerName: 'Opiekun', flex: 1, valueGetter: params => params.row.order.guardian_name },
  { field: 'participant', headerName: 'Uczestnik', flex: 1, valueGetter: params => params.row.order.participant_name }
];

const MatchOrder = ({ open, handleClose, orders, transaction, setTransactions, collect }) => {
  const { seasonYear } = useSelector(state => state.app);
  const { mutate } = useMutation(matchBankStatementsWithOrdersAction);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const handleMatch = async () => {
    if (transaction.document) {
      alert('Ta transakcja została już dopasowana');

      return;
    }
    const { error: mutateError, payload } = await mutate({ 'transactions': [transaction], 'order_id': selectionModel[0], collect, season_year: seasonYear });
    if (!mutateError) {
      setTransactions(prev => prev.map(t => {
        if (payload.results.length > 0 && t.id !== payload.results[0].bank_statement_id) {
          return t;
        }

        if (_.isNil(payload.results.length > 0 && payload.results[0].best_match)) {
          return { ...t, bestMatch: 'Brak dopasowania' };
        }

        const order = orders.find(item => item.id === selectionModel[0]);

        return {
          ...t,
          order_id: payload.results[0].best_match.order.id,
          bestMatch: payload.results[0].best_match.order.identifier,
          guardian: payload.results[0].best_match.order.guardian_name,
          participant: payload.results[0].best_match.order.participant_name,
          weight_percentage: order.weight_percentage,
          order_name: payload.results[0].best_match.order_name,
          document_name: payload.results[0].best_match.document_name
        };
      }));
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '80vw', height: '80vh' }}>
        <CardHeader
          title="Dopasuj transakcje do zamówienia"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <ArrowBackIcon />
            </IconButton>
          }
        />
        <CardContent sx={{ height: '80%' }}>
          <Stack sx={{ height: '5%' }} direction="row" spacing={2} alignItems="center">
            <Typography variant="body2">tytuł: <span style={{ fontWeight: 'bold' }}>{_.isNil(transaction) ? '' : transaction.title}</span></Typography>
            <Typography variant="body2">kontrahent: <span style={{ fontWeight: 'bold' }}>{_.isNil(transaction) ? '' : transaction.contractor}</span></Typography>
          </Stack>
          <DataGridPro
            rows={orders}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            pagination
            checkboxSelection={false}
            components={{ Toolbar: GridToolbar }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
            onSelectionModelChange={newSelection => {
              setSelectionModel(newSelection);
            }}
            selectionModel={selectionModel}
          />
          <Box sx={{ height: '15%' }} display="flex" justifyContent="center" alignItems="center" >
            <Button disabled={selectionModel.length === 0} sx={{ width: '50%' }} variant="contained" onClick={handleMatch}>Dopasuj</Button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default MatchOrder;

